import type { SyncStatus } from '../../data/syncClient';

const changes = (n: number) => `${n} ${n === 1 ? 'change' : 'changes'} waiting`;

const REFUSED = "Some changes couldn't be saved.";

function baseLabel(s: SyncStatus): string {
  switch (s.state) {
    case 'syncing':
      return 'Syncing…';
    case 'offline':
      return s.pending > 0 ? `Offline · ${changes(s.pending)}` : 'Offline';
    case 'error':
      return s.pending > 0
        ? `Couldn't sync · ${changes(s.pending)}`
        : "Couldn't sync. Trying again.";
    case 'signed_out':
      return 'Signed out';
    default:
      return s.pending > 0 ? changes(s.pending) : 'Synced';
  }
}

/** One plain line for the sync state; final server refusals (conventions §14) are said calmly. */
export function syncLabel(s: SyncStatus): string {
  const base = baseLabel(s);
  if (!s.rejected || s.state === 'syncing' || s.state === 'signed_out') return base;
  return base === 'Synced' ? REFUSED : `${base} · ${REFUSED}`;
}
